import baseDictionary from '../constants/localize/en_US';

export type Dictionary = Record<string, string>;

export let locale: Dictionary = baseDictionary;

export function setDictionary(dictionary: Dictionary): void {
  locale = {
    ...baseDictionary,
    ...dictionary,
  };
}

export function t(key: string): string {
  return locale[key] ?? key;
}
